import { Injectable } from '@angular/core';


@Injectable()
export class AddRuleHelperFunctions {
  thresholdList: any[];
  ruleConfiguration:any  = { deductions: [], shares: [], rules: [] };
  constructor() {
    const me = this;
  }

  addRuleGroup() {
    const me = this;
    const conditionObj = {
      name: '',
      amount: '',
      general: "",
      status: false,
      edit : true
    };
   
    me.ruleConfiguration.deductions.push(conditionObj);
  }

  addRuleCondition(parentIndex?: number) {
    const me = this;
    const conditionObj = {
      max_amt: '',
      min_amt: '',
      percentage: '',
      edit : true
    };
    me.ruleConfiguration.shares.push(conditionObj);

  }

  addConditionInGroup(groupIndex) {
    const me = this;
    const conditionObj = {
      threshold: '',
      outcome: null
    };
    me.ruleConfiguration.rules[groupIndex]['rules'].push(conditionObj);
  }

  removeRule(index: number) {
    const me = this;
    me.ruleConfiguration.rules.splice(index, 1);
  }

  removeRuleCondition(childIndex: number, parentIndex?: number) {
    const me = this;
    if (parentIndex) {
      me.ruleConfiguration.rules[parentIndex]['rules'].splice(childIndex, 1);
    } else {
      me.ruleConfiguration.rules.splice(childIndex, 1);
    }
  }

  removeRuleV2(childIndex: number, parentIndex?) {
    const me = this;

      me.ruleConfiguration[parentIndex].splice(childIndex, 1);
   
  }

  validateRules(): boolean {
    const me = this;
    let response = true;
    if (me.ruleConfiguration.rules.length === 0) {
      response = false;
    } else {
      me.ruleConfiguration.rules.forEach(rule => {
        if (rule.hasOwnProperty('rules')) {
          for (let index = 0; index < rule.rules.length; index++) {
            const element = rule.rules[index];
            if (element.threshold === '' || element.outcome === null) {
              response = false;
              return;
            }
          }
        } else {
          if (rule.threshold === '' || rule.outcome === null) {
            response = false;
            return;
          }
        }
      });
    }


    // console.log('validateRules ', response)
    return response;
  }
  getRanges(){
    const array = [];
    for(const item of this.ruleConfiguration.shares){
      const newItem = item;
      newItem.edit = undefined;
      array.push(newItem);

    }
    return array;
  }
}

